import { styled } from '@mui/material/styles';

const Dot = styled('span')(({ color }) => ({
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: color,
    display: 'inline-block',
    flexShrink: 0,
}));

const STATUS_COLORS = {
    0: 'var(--warning-main)', // pending
    1: 'var(--success-main)', // active
    2: 'var(--error-main)', // failed
    3: 'var(--error-main)',
};

const StatusDot = ({ status }) => <Dot color={STATUS_COLORS[status] || 'var(--action-disabled)'} />;

export default StatusDot;
